import React from "react";
import type { FC } from "react";
import styles from "./RadioButton.module.css";
import { isDisabled } from "@testing-library/user-event/dist/utils";

type RadioButtonProps = {
  label?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  hideRadio?:boolean,
  disable?:boolean
  readonly?:boolean
};

const RadioButton: FC<RadioButtonProps> = ({
  label,
  name,
  value,
  checked,
  onChange,
  className,
  style,
  hideRadio,
  disable,
  readonly
}) => {
    const disabledClass = disable ? styles.disabled : '';
  return (
    <label className={`${styles.radioLabel} ${className || ""}`} style={style}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      className={`${styles.radioInput} ${hideRadio ? styles.hiddenRadio : ""}`}
      disabled={disable}
readOnly={readonly}
      />
      <span className={styles.customRadio}></span>
      {label}
    </label>
  );
};

export default RadioButton;
